<template>
    <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 grid grid-cols-12 gap-6 max-w-6xl mx-auto mb-12">
            <!-- BEGIN: General Report -->
            <div class="col-span-12 mt-8">
                <div class="intro-y flex items-center h-10">
                    <h2 class="text-lg font-medium truncate mr-5">Accesos Directos</h2>
                </div>
                <div class="grid grid-cols-12 gap-6 mt-5">
                    <div v-if="!isAdmin" class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                        <div class="report-box zoom-in">
                            <div class="box p-5 cursor-pointer" @click="linkTo('side-menu-carga')">
                                <div class="flex py-4 justify-between items-center">
                                    <InboxIcon class=" text-theme-10 w-20 h-20" />
                                    <div class="ml-auto w-32">
                                        <Tippy tag="div" class="report-box__indicator flex justify-between items-center bg-theme-9 cursor-pointer" content="Area de carga">
                                            Área de carga
                                            <ChevronRightIcon class="w-4 h-4" />
                                        </Tippy>
                                        <div class="text-xs text-gray-600 mt-1 ">Subir un documento<br><strong>El tamaño máximo de los archivos es de 10MB</strong></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="isAdmin" class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                        <div class="report-box zoom-in">
                            <div class="box p-5 cursor-pointer" @click="linkTo('side-menu-descarga')">
                                <div class="flex py-4 justify-between items-center">
                                    <HardDriveIcon class=" text-theme-10 w-20 h-20" />
                                    <div class="ml-auto w-32">
                                        <Tippy tag="div" class="report-box__indicator flex justify-between items-center bg-theme-9 cursor-pointer" content="Area de carga">
                                            Área de descarga
                                            <ChevronRightIcon class="w-4 h-4" />
                                        </Tippy>
                                        <div class="text-xs text-gray-600 mt-1 ">Subir un documento<br><strong>El tamaño máximo de los archivos es de 10MB</strong></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isAdmin" class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                        <div class="report-box zoom-in">
                            <div class="box p-5 cursor-pointer" @click="linkTo('side-menu-control')">
                                <div class="flex py-4 justify-between items-center">
                                    <FileTextIcon class=" text-theme-10 w-20 h-20" />
                                    <div class="ml-auto w-32">
                                        <Tippy tag="div" class="report-box__indicator flex justify-between items-center bg-theme-11 cursor-pointer" content="Control de Documentos">
                                            Control de Docs.
                                            <ChevronRightIcon class="w-4 h-4" />
                                        </Tippy>
                                        <div class="text-xs text-gray-600 mt-1 ">Controla el estado de los documentos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="isAdmin" class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                        <div class="report-box zoom-in">
                            <div class="box p-5 cursor-pointer" @click="linkTo('side-menu-control-docs')">
                                <div class="flex py-4 justify-between items-center">
                                    <FileTextIcon class=" text-theme-10 w-20 h-20" />
                                    <div class="ml-auto w-32">
                                        <Tippy tag="div" class="report-box__indicator flex justify-between items-center bg-theme-11 cursor-pointer" content="Control de Documentos">
                                            Control de Docs.
                                            <ChevronRightIcon class="w-4 h-4" />
                                        </Tippy>
                                        <div class="text-xs text-gray-600 mt-1 ">Controla el estado de los documentos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                        <div class="report-box zoom-in">
                            <div class="box p-5 cursor-pointer" @click="linkTo('side-menu-tablon')">
                                <div class="flex py-4 justify-between items-center">
                                    <LayoutIcon class=" text-theme-10 w-20 h-20" />
                                    <div class="ml-auto w-32">
                                        <Tippy tag="div" class="report-box__indicator flex justify-between items-center bg-theme-1 cursor-pointer" content="Tablón de anuncios">
                                            Tablón de anun.
                                            <ChevronRightIcon class="w-4 h-4" />
                                        </Tippy>
                                        <div class="text-xs text-gray-600 mt-1 ">Últimas noticias</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isAdmin" class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                        <div class="report-box zoom-in">
                            <div class="box p-5 cursor-pointer" @click="linkTo('side-menu-notificaciones')">
                                <div class="flex py-4 justify-between items-center">
                                    <MessageSquareIcon class=" text-theme-10 w-20 h-20" />
                                    <div class="ml-auto w-32">
                                        <Tippy tag="div" class="report-box__indicator flex justify-between items-center bg-theme-12 cursor-pointer" content="Notificaciones">
                                            Notificaciones
                                            <ChevronRightIcon class="w-4 h-4" />
                                        </Tippy>
                                        <div class="text-xs text-gray-600 mt-1 ">Ver todas las notificaciones</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END: General Report -->
            <!-- BEGIN: General Report -->
            <div v-if="!isAdmin" class="col-span-12 mt-8">
                <div class="intro-y flex items-center h-10">
                    <h2 class="text-lg font-medium truncate mr-5">Documentos Faltantes</h2>
                    <button @click="linkTo('side-menu-control')" class="ml-auto dropdown-toggle cursor-pointer button text-white bg-theme-1 shadow-md flex items-center">
                        <FileTextIcon class="mr-2" />
                        Control de Documentos
                    </button>
                </div>
                <div class="col-span-12 grid grid-cols-12 gap-6 mt-8">
                    <div class="col-span-12 sm:col-span-6 xxl:col-span-3 intro-y">
                        <div class="mini-report-chart box p-5 zoom-in">
                            <div class="flex items-center">
                                <div class="w-2/4 flex-none">
                                    <div class="text-lg font-medium truncate">EMPRESA</div>
                                    <div class="text-gray-600 mt-1" v-if="reports.EMPRESA">{{reports.EMPRESA[0]}} de {{ reports.EMPRESA[1] }} Documentos subidos</div>
                                </div>
                                <div class="flex-none ml-auto relative">
                                    <ReportDonutChart1 :width="90" :height="90" />
                                    <div v-if="reports.EMPRESA" class="font-medium absolute w-full h-full flex items-center justify-center top-0 left-0">
                                        {{ reports.EMPRESA[3] }}%
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-span-12 sm:col-span-6 xxl:col-span-3 intro-y">
                        <div class="mini-report-chart box p-5 zoom-in">
                            <div class="flex items-center">
                                <div class="w-2/4 flex-none">
                                    <div class="text-lg font-medium truncate">EMPLEADOS</div>
                                    <div class="text-gray-600 mt-1" v-if="reports.EMPLEADOS">{{reports.EMPLEADOS[0]}} de {{ reports.EMPLEADOS[1] }} Documentos subidos</div>
                                </div>
                                <div class="flex-none ml-auto relative">
                                    <ReportDonutChart1 :width="90" :height="90" />
                                    <div v-if="reports.EMPLEADOS" class="font-medium absolute w-full h-full flex items-center justify-center top-0 left-0">
                                        {{ reports.EMPLEADOS[3] }}%
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-span-12 sm:col-span-6 xxl:col-span-3 intro-y">
                        <div class="mini-report-chart box p-5 zoom-in">
                            <div class="flex items-center">
                                <div class="w-2/4 flex-none">
                                    <div class="text-lg font-medium truncate">SUBCONTRATAS</div>
                                    <div class="text-gray-600 mt-1" v-if="reports.SUBCONTRATAS">{{reports.SUBCONTRATAS[0]}} de {{ reports.SUBCONTRATAS[1] }} Documentos subidos</div>
                                </div>
                                <div class="flex-none ml-auto relative">
                                    <ReportDonutChart1 :width="90" :height="90" />
                                    <div v-if="reports.SUBCONTRATAS" class="font-medium absolute w-full h-full flex items-center justify-center top-0 left-0">
                                        {{ reports.SUBCONTRATAS[3] }}%
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-span-12 sm:col-span-6 xxl:col-span-3 intro-y">
                        <div class="mini-report-chart box p-5 zoom-in">
                            <div class="flex items-center">
                                <div class="w-2/4 flex-none">
                                    <div class="text-lg font-medium truncate">MAQUINARIA</div>
                                    <div class="text-gray-600 mt-1" v-if="reports.MAQUINARIA">{{reports.MAQUINARIA[0]}} de {{ reports.MAQUINARIA[1] }} Documentos subidos</div>
                                </div>
                                <div class="flex-none ml-auto relative">
                                    <ReportDonutChart1 :width="90" :height="90" />
                                    <div v-if="reports.MAQUINARIA" class="font-medium absolute w-full h-full flex items-center justify-center top-0 left-0">
                                        {{ reports.MAQUINARIA[3] }}%
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END: General Report -->
            <!-- BEGIN: Notificaciones -->
            <div v-if="!isAdmin" class="col-span-12 mt-8">
                <div class="intro-y flex items-center h-10">
                    <h2 class="text-lg font-medium truncate mr-5">Últimas notificaciones</h2>
                    <button @click="linkTo('side-menu-notificaciones')" class="ml-auto cursor-pointer dropdown-toggle button text-white bg-theme-11 shadow-md flex items-center">
                        <MessageSquareIcon class="mr-2" />
                        Ir a notificaciones
                    </button>
                </div>
                <div class="intro-y inbox box mt-5">
                    <notificaciones-list :opciones="false" :limit="5"></notificaciones-list>
                </div>
            </div>
            <!-- END: Notificaciones -->
            <!-- BEGIN: Directory & Files -->
            <div v-if="!isAdmin" class="col-span-12 mt-8">
                <div class="intro-y flex items-center h-10">
                    <h2 class="text-lg font-medium truncate mr-5">Últimos Documentos de descarga</h2>
                    <button @click="linkTo('side-menu-descarga')" class="ml-auto cursor-pointer dropdown-toggle button text-white bg-theme-1 shadow-md flex items-center">
                        <HardDriveIcon class="mr-2" />
                        Ir a descargas
                    </button>
                </div>
                <file-list :limit="4" :order="'num desc'"></file-list>
            </div>
            <!-- END: Directory & Files -->
        </div>
    </div>
</template>
<script>
import ReportDonutChart1 from "@/components/ReportDonutChart1";

import FileList from "@/components/FileList";
import NotificacionesList from "@/components/NotificacionesList";

export default {
    components: {
        FileList,
        ReportDonutChart1,
        NotificacionesList
    },
    data() {
        return {
            salesReportFilter: "",
            reports: {
                EMPRESA: null,
                EMPLEADOS: null,
                SUBCONTRATAS: null,
                MAQUINARIA: null
            }
        };
    },
    computed: {
        isAdmin() {
            return globalThis.bus.admin;
        }
    },
    mounted() {
        let data, calc;
        if (this.$d().user.centro) {
            data = this.totalFiles(this.$d().user.centro.config.EMPRESA)
            if (data[1] !== 0) {
                calc = parseInt((data[0] * 100) / data[1]);
            } else {
                calc = 100;
            }
            this.reports.EMPRESA = [...data, data[1] - data[0], calc];

            data = this.totalFilesRec(this.$d().user.centro.config.EMPLEADOS)
            if (data[1] !== 0) {
                calc = parseInt((data[0] * 100) / data[1]);
            } else {
                calc = 100;
            }
            this.reports.EMPLEADOS = [...data, data[1] - data[0], calc];

            data = this.totalFilesRec(this.$d().user.centro.config.MAQUINARIA)
            if (data[1] !== 0) {
                calc = parseInt((data[0] * 100) / data[1]);
            } else {
                calc = 100;
            }
            this.reports.MAQUINARIA = [...data, data[1] - data[0], calc];

            data = this.totalFilesRec(this.$d().user.centro.config.SUBCONTRATAS)
            if (data[1] !== 0) {
                calc = parseInt((data[0] * 100) / data[1]);
            } else {
                calc = 100;
            }
            this.reports.SUBCONTRATAS = [...data, data[1] - data[0], calc];
        }
    },
    methods: {
        linkTo(pageName) {
            this.$router.push({
                name: pageName
            });
        },
        prevImportantNotes() {
            this.$refs["important-notes"].prev();
        },
        nextImportantNotes() {
            this.$refs["important-notes"].next();
        }
    }
};
</script>